import React from 'react'

const Layout = ({children}) => {
    return (
        <main style={{width: '100%'}}>
            {children}
        </main>
    )
}

export default Layout
